import type {
	DetailsPanelContentContributorsQuery_contentContributors_nodes as Nodes,
	DetailsPanelContentContributorsQuery_contentContributors_nodes_KnownUser as KnownUser,
	DetailsPanelContentContributorsQuery_contentContributors_nodes_User as User,
} from '../queries/__types__/DetailsPanelContentContributorsQuery';

export const hasAccountId = (ownedBy: Nodes): ownedBy is KnownUser | User =>
	!!ownedBy && 'accountId' in ownedBy;
